import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '../core/configuration.service';


@Injectable()
export class StandingInstructionService {

  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }


  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `standingInstruction?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getStandingInstructionTypes(): Observable<any> {
    
    return this.httpClient.get(this.baseApiUrl + 'standingInstruction/types').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  // getFiltered(filter: string, pageIndex: number, pageSize: number,
  //   sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

  //   const params = {
  //     filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
  //   };

  //   return this.httpClient.post(this.baseApiUrl + 'standingInstruction/filter', params).pipe(
  //     map((res: any) => res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }

  getFiltered(filter: string, pageIndex: number, pageSize: number,sortColumn: string, sortAscending: boolean,
     isMaintenance: boolean = false, type: number, executionRule: number,periodicity: number,status: number): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance,type,executionRule,periodicity,status
    };

    return this.httpClient.post(this.baseApiUrl + 'standingInstruction/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `standingInstruction/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(standingInstruction: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'standingInstruction', standingInstruction).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(standingInstruction: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'standingInstruction', standingInstruction).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(standingInstruction: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'standingInstruction/authorise', standingInstruction).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `standingInstruction/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}
